import { AppText } from '../../../../../ui/text/AppText';

export function AmountBodyCell({ amount, className = '' }) {
  return <AppText className={className}>{amount ? amount.toString() : '-'}</AppText>;
}
